import { displayRuleHelper } from "display-rules";
import FormModelGenerator from "./form-model-generator";
import { stateNameByValue } from "../states";

export function ruleDataFor(data) {
  const ruleData = { ...data };
  const currentState = stateNameByValue(ruleData.state_id);
  if (!ruleData.state || currentState != ruleData.state) {
    ruleData.state = currentState;
  }
  return ruleData;
}

export function visibleFields(fields, data) {
  const ruleData = ruleDataFor(data);
  return fields.filter((field) =>
    displayRuleHelper(field.display_rules, ruleData)
  );
}

export function visibleFormFields(pages, data) {
  const fields = pages.flatMap((page) => page.fields || []);
  const dataWithDefaults = new FormModelGenerator(fields, data).generateData;
  return visibleFields(fields, dataWithDefaults);
}
